@if (imagesArray) {
<div class="images">
    <div class="row">
        <div class="caption">{{meta().info}}</div>
        <div class="array" [formArray]="imagesArray">
            @for (image of images; track i; let i = $index) {
            <app-image [formArray]="imagesArray" [model]="image" [meta]="metaImage" [arrayIndex]="i"
                [readonly]="readonly()" (clear)="onDelete(i)"></app-image>
            }
        </div>
        <button type="button" class="button" [disabled]="readonly()" (click)="onAdd()">
            <mat-icon>add_box</mat-icon>
        </button>
    </div>
</div>
}
